import KunLoading96 from './src/index'

KunLoading96.install = function (Vue) {
	Vue.component(KunLoading96.name, KunLoading96);
}

export default KunLoading96;
